export enum FiltersFormSheetMessage {
  BUTTON_RESET_FILTERS = 'Reset filters',
  BUTTON_APPLY_FILTERS = 'Apply filters',
  BUTTON_UNSELECT_ALL = 'Unselect all',
  BUTTON_UNSELECT = 'Unselect',
  BUTTON_DONE = 'Done',
}
